import React from 'react';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import {IAppConfig } from "../App_v01_Interfaces";


interface AppConfigProps{
  appConfig: IAppConfig;
}//end:



export const NavBar_v03Responsive_DISCOUNT_PAINTERS: React.FC<AppConfigProps> = ({appConfig}) => {
  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container>
        {/* LOGO with responsive swap */}
        <Navbar.Brand href="https://LegacyInsuranceNetwork.com">
          {/* Large screen logo */}
          <img
            src={appConfig.images[0].imagePath + "LogoDesktop.png"}
            alt={appConfig.companyDisplayName}
            className="desktopLogoCSS1"
          />
          {/* Small screen logo */}
          <img     
            src={appConfig.images[0].imagePath + "LogoPhone.png"}
            alt={appConfig.companyDisplayName}
            className="phoneLogoCSS1"
          /> 

        </Navbar.Brand>

        {/* Toggle button for mobile menu */}
        {/* <Navbar.Toggle aria-controls="basic-navbar-nav" /> */}

        {/* Collapsible nav items */}
         {/* <Navbar bg="light" expand="lg">
              <Container>
                <Navbar.Brand href="/">MyApp</Navbar.Brand>
                <Navbar.Toggle aria-controls="basic-navbar-nav" />
                <Navbar.Collapse id="basic-navbar-nav">
                  <Nav className="me-auto">
                    <NavDropdown title="Insurance" id="insurance-dropdown">
                      <NavDropdown.Item href="/businessInsurance">Business Insurance</NavDropdown.Item>
                      <NavDropdown.Item href="/personalInsurance">Personal Insurance</NavDropdown.Item>
                      <NavDropdown.Item href="/broker">Broker</NavDropdown.Item>
                    </NavDropdown>
                    
                  </Nav>
                </Navbar.Collapse>
              </Container>
            </Navbar>
      */}
        
        {/* <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/home">Home</Nav.Link>

             <NavDropdown title="Insurance" id="insurance-dropdown">
                      <NavDropdown.Item href="/businessInsurance">Business Insurance</NavDropdown.Item>
                      <NavDropdown.Item href="/personalInsurance">Personal Insurance</NavDropdown.Item>
                      <NavDropdown.Item href="/broker">Broker vs. Captive Agent</NavDropdown.Item>
                      <NavDropdown.Item href="/faq">FAQ</NavDropdown.Item>
            </NavDropdown>
            
            <Nav.Link href="/contact">Contact</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
          </Nav>
        </Navbar.Collapse>  */}


        
        {/* 
        
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto">
            <Nav.Link href="/">Home</Nav.Link>
            <Nav.Link href="/businessInsurance">Buiness Insurance</Nav.Link>
            <Nav.Link href="/personalInsurance">Personal Insurnace</Nav.Link>
            <Nav.Link href="/broker">Broker vs Captive</Nav.Link>
            <Nav.Link href="/faq">FAQ</Nav.Link>
            <Nav.Link href="/contact">Contact</Nav.Link>
            <Nav.Link href="/about">About</Nav.Link>
          </Nav>
        </Navbar.Collapse> 
        
        */}
      </Container>
    </Navbar>
  );
};

export default NavBar_v03Responsive_DISCOUNT_PAINTERS;






        //=====================  park it


        {/* <img
            src="./SundanceLogoAndLettersWT.png"
            alt={appConfig.companyDisplayName}
            title={appConfig.companyLegalName}
          /> */}



        {/* src="/sundance-images/SundanceLogoDesktop.png" 
            src="/sundance-images/SundanceLogoPhone.png"
        */}
        